var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElementCer01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 172,
    height: 172,
    viewBox: "0 0 172 172",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M0 86C0 38.5035 38.5035 0 86 0C133.496 0 172 38.5035 172 86C172 133.496 133.496 172 86 172C38.5035 172 0 133.496 0 86ZM146.2 86C146.2 52.7525 119.248 25.8 86 25.8C52.7525 25.8 25.8 52.7525 25.8 86C25.8 119.248 52.7525 146.2 86 146.2C119.248 146.2 146.2 119.248 146.2 86Z",
    fill: "url(#paint0_linear_188_509)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_188_509",
    x1: 172,
    y1: 172,
    x2: 28.6685,
    y2: 149.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF47F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.510417,
    stopColor: "#8360F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElementCer01);
export default __webpack_public_path__ + "static/media/element-cer-01.73fca8947658dedb48640e2b60ec0411.svg";
export { ForwardRef as ReactComponent };